(function (root) {
  'use strict';
  const SIZE_INTERESTS = Object.freeze(['XS', 'S', 'M', 'L', 'XL', 'XXL', 'UNSURE']);

  function designOptionLabel(product, locale = 'en') {
    const chinese = /^zh(?:-|$)/i.test(locale);
    const number = Number.isInteger(product.number) && product.number > 0 ? String(product.number).padStart(2, '0') : product.id;
    const title = chinese ? product.titleZh || product.title : product.title || product.titleZh;
    const color = chinese ? product.colorZh || product.color : product.color || product.colorZh;
    return `${number} / ${title}${color ? ` · ${color}` : ''}`;
  }

  function endpoint(base) {
    try {
      const url = new URL(base);
      if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash) return null;
      if (/^(?:localhost|127\.|0\.0\.0\.0|\[::1\])/.test(url.hostname)) return null;
      return `${url.href.replace(/\/+$/, '')}/v1/interests`;
    } catch (_error) { return null; }
  }

  function registrationReady(config) {
    return config?.dropRegistrationEnabled === true && Boolean(endpoint(config.engagementApiUrl))
      && typeof config.dropPolicyVersion === 'string' && config.dropPolicyVersion.trim().length > 0
      && config.privacyReady === true;
  }

  function interestPayload(input, catalogue, config) {
    if (!registrationReady(config)) return { error: 'registration_closed' };
    const product = root.HEIREdit?.resolveDesign(input?.catalogueId, catalogue);
    if (!product) return { error: 'invalid_design' };
    if (!SIZE_INTERESTS.includes(input.sizeInterest)) return { error: 'invalid_size' };
    if (input.colorInterest !== product.color) return { error: 'invalid_color' };
    if (typeof input.email !== 'string' || input.email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.email.trim())) return { error: 'invalid_email' };
    if (input.consent !== true) return { error: 'consent_required' };
    return { value: {
      email: input.email.trim(), catalogueId: product.id, sizeInterest: input.sizeInterest,
      colorInterest: product.color, locale: /^zh(?:-|$)/i.test(input.locale || '') ? 'zh-CN' : 'en',
      consent: true, policyVersion: config.dropPolicyVersion.trim()
    } };
  }

  root.HEIRDropRoom = { SIZE_INTERESTS, designOptionLabel, endpoint, registrationReady, interestPayload };
  if (typeof document === 'undefined') return;
  const config = root.HEIR || {};
  const section = document.querySelector('[data-drop-room]');
  if (!section || !root.HEIREdit) return;
  const strings = JSON.parse(section.querySelector('[data-drop-strings]')?.textContent || '{}');
  const chinese = /^zh(?:-|$)/i.test(config.locale || document.documentElement.lang);
  const form = section.querySelector('[data-drop-form]');
  const collection = form?.querySelector('[name="collection"]');
  const design = form?.querySelector('[name="catalogueId"]');
  const color = form?.querySelector('[name="colorInterest"]');
  const size = form?.querySelector('[name="sizeInterest"]');
  const email = form?.querySelector('[name="email"]');
  const consent = form?.querySelector('[name="consent"]');
  const submit = form?.querySelector('[data-drop-submit]');
  const status = section.querySelector('[data-drop-status]');
  const save = form?.querySelector('[data-heir-save-design]');
  const preview = section.querySelector('[data-drop-preview]');
  if (!form || !collection || !design || !color || !size || !email || !consent || !submit || !status || !save || !preview) return;
  const active = registrationReady(config) && config.localPreview !== true;
  let busy = false;
  let catalogue = [];
  let selected;
  const option = (value, label) => { const node = document.createElement('option'); node.value = value; node.textContent = label; return node; };
  function readiness() {
    submit.disabled = busy || !selected || !active;
    email.disabled = consent.disabled = !active || busy;
    collection.disabled = design.disabled = color.disabled = size.disabled = busy;
    form.setAttribute('aria-busy', String(busy));
  }
  function selectDesign() {
    selected = catalogue.find((product) => product.id === design.value);
    if (!selected) return;
    color.replaceChildren(option(selected.color, chinese ? selected.colorZh || selected.color : selected.color));
    save.dataset.heirSaveDesign = selected.id;
    preview.src = root.HEIREdit.asset(selected.image);
    preview.alt = chinese ? selected.titleZh || selected.title : selected.title;
    section.querySelector('[data-drop-design-title]').textContent = preview.alt;
    section.querySelector('[data-drop-collection-title]').textContent = selected.collection;
    root.HEIREdit.refreshControls(form);
    readiness();
  }
  function selectCollection(preferredId) {
    const group = catalogue.filter((product) => product.collection === collection.value);
    design.replaceChildren(...group.map((product) => option(product.id, designOptionLabel(product, chinese ? 'zh-CN' : 'en'))));
    if (group.some((product) => product.id === preferredId)) design.value = preferredId;
    selectDesign();
  }
  async function post(url, payload) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', body: JSON.stringify(payload), signal: controller.signal });
      const body = await response.json();
      return { response, body };
    } finally { clearTimeout(timeout); }
  }
  root.HEIREdit.ready.then((runtime) => {
    if (!runtime) { status.textContent = strings.load_error; return; }
    catalogue = runtime.catalogue;
    const preferred = root.HEIREdit.resolveDesign(new URLSearchParams(root.location.search).get('design'), catalogue)
      || catalogue.find((product) => product.id === '13-core-hoodie') || catalogue[0];
    collection.replaceChildren(...[...new Set(catalogue.map((product) => product.collection))].map((name) => option(name, name)));
    collection.value = preferred.collection;
    selectCollection(preferred.id);
    status.textContent = active ? strings.ready : strings.closed;
    section.querySelector('[data-drop-loading]').hidden = true;
  });
  collection.addEventListener('change', () => selectCollection());
  design.addEventListener('change', selectDesign);
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (busy) return;
    if (!active) { status.textContent = strings.closed; return; }
    const payload = interestPayload({ email: email.value, catalogueId: design.value, colorInterest: color.value, sizeInterest: size.value, consent: consent.checked, locale: config.locale }, catalogue, config);
    if (payload.error) { status.textContent = strings[payload.error] || strings.invalid_details; return; }
    busy = true; readiness(); status.textContent = strings.sending;
    try {
      const { response, body } = await post(endpoint(config.engagementApiUrl), payload.value);
      if (response.status === 202 && body.status === 'accepted') {
        status.textContent = strings.accepted;
        root.HEIRInsights?.track?.('interest', payload.value.catalogueId);
        email.value = ''; consent.checked = false;
      } else if (body.error === 'interest_capture_disabled') status.textContent = strings.closed;
      else status.textContent = strings.submit_error;
    } catch (_error) { status.textContent = strings.submit_error; }
    finally { busy = false; readiness(); }
  });

  // Confirmation tokens never enter storage, logs, analytics, or referrers.
  let handoff = null;
  try { if (typeof root.__heirTakeLinkToken === 'function') handoff = root.__heirTakeLinkToken(); }
  catch (_error) { /* An expired one-time handoff must not break the page. */ }
  const fragment = handoff ? new URLSearchParams() : new URLSearchParams(root.location.hash.slice(1));
  const mode = handoff && ['confirm', 'unsubscribe'].includes(handoff.kind) ? handoff.kind
    : fragment.has('confirm') ? 'confirm' : fragment.has('unsubscribe') ? 'unsubscribe' : null;
  if (mode) {
    let token = handoff ? handoff.token || '' : fragment.get(mode) || '';
    handoff = null;
    root.history.replaceState(root.history.state, '', root.location.pathname + root.location.search);
    const box = section.querySelector('[data-drop-token-panel]');
    const button = box.querySelector('[data-drop-token-action]');
    const message = box.querySelector('[data-drop-token-status]');
    box.hidden = false;
    button.textContent = mode === 'confirm' ? strings.confirm_action : strings.unsubscribe_action;
    message.textContent = mode === 'confirm' ? strings.confirm_prompt : strings.unsubscribe_prompt;
    const canProcess = Boolean(endpoint(config.engagementApiUrl)) && config.localPreview !== true && /^[A-Za-z0-9_-]{43}$/.test(token);
    button.disabled = !canProcess;
    if (!canProcess) message.textContent = strings.token_unavailable;
    button.addEventListener('click', async () => {
      if (!token || button.disabled) return;
      button.disabled = true; message.textContent = strings.sending;
      try {
        const { response, body } = await post(`${endpoint(config.engagementApiUrl)}/${mode}`, { token });
        if (response.ok && body.status === 'processed') { token = ''; message.textContent = strings.token_processed; }
        else { message.textContent = strings.token_error; button.disabled = false; }
      } catch (_error) { message.textContent = strings.token_error; button.disabled = false; }
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
